import $ from "jquery";

const checkoutDeliveryMode = {
    $pageBody: $(document.body),

    bindHandlers() {
        this.$pageBody.on('click', '.js-show-store-selector', (event) => {
            document.getElementById('js-selected-store-preview').classList.add('ng-hide');
            document.getElementById('js-storeselector').classList.remove('ng-hide');
        });

        this.$pageBody.on('click', '.js-select-delivery-mode', (event) => {
            const form = $(event.currentTarget).closest('.js-delivery-mode-form');
            form.submit();
        });
    }
};

// DOM ready
$(() => {
    if ($('#js-storeselector').length) {
        checkoutDeliveryMode.bindHandlers();
    }
});

export default checkoutDeliveryMode;
